// extracted by mini-css-extract-plugin
var _1 = "AiCopilotChatPanel-module__actions--Z6yIy";
var _2 = "AiCopilotChatPanel-module__actionsLeft--ap4c8";
var _3 = "AiCopilotChatPanel-module__animateUploadProgressBarWidth--Vbo3i";
var _4 = "AiCopilotChatPanel-module__animatedBackground--cFcRS";
var _5 = "AiCopilotChatPanel-module__badge--kQmNi";
var _6 = "AiCopilotChatPanel-module__container--EPG6e";
var _7 = "AiCopilotChatPanel-module__conversation--a6HA_";
var _8 = "AiCopilotChatPanel-module__footer--Kg_aj";
var _9 = "AiCopilotChatPanel-module__hasMessages--PXZmC";
var _a = "AiCopilotChatPanel-module__iconButton--q6wQ9";
var _b = "AiCopilotChatPanel-module__inputContainer--rpgqh";
var _c = "AiCopilotChatPanel-module__loading--K9zHK";
var _d = "AiCopilotChatPanel-module__message--MVTHr";
var _e = "AiCopilotChatPanel-module__messageComposer--jfDV1";
var _f = "AiCopilotChatPanel-module__messagesContainer--b_8ne";
var _10 = "40px";
var _11 = "AiCopilotChatPanel-module__scrollToBottomButton--KoApr";
var _12 = "AiCopilotChatPanel-module__scrollToBottomButtonContainer--W1OmY";
var _13 = "AiCopilotChatPanel-module__sources--dPr3e";
var _14 = "AiCopilotChatPanel-module__system--OtyXk";
var _15 = "AiCopilotChatPanel-module__user--mX7yA";
export { _1 as "actions", _2 as "actionsLeft", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "badge", _6 as "container", _7 as "conversation", _8 as "footer", _9 as "hasMessages", _a as "iconButton", _b as "inputContainer", _c as "loading", _d as "message", _e as "messageComposer", _f as "messagesContainer", _10 as "paddingBottom", _11 as "scrollToBottomButton", _12 as "scrollToBottomButtonContainer", _13 as "sources", _14 as "system", _15 as "user" }
